module.exports = __webpack_public_path__ + "906459e28850f662be74b5762fe9e234.svg";